



































import { Component, Vue, Prop } from 'vue-property-decorator'
import { localStore } from '@/_utils/localstore'

import Menu from './patials/Menu.vue'
import ViewContents from './patials/ViewContents.vue'

@Component({
  components: { Menu, ViewContents },
})
export default class Sidebar extends Vue {
  @Prop()
  logo!: string

  reduceNavKey = 'reduceNav'
  componentKey: number = 1
  isReduced: boolean = false

  handleToggleReduceMenu(): void {
    const key = this.reduceNavKey
    const curr = localStore.getItem(key)
    this.isReduced = !curr

    if (curr) {
      localStore.remove(key)
    } else {
      localStore.setItem(key, '1')
    }

    this.componentKey++
  }

  mounted() {
    this.isReduced = !!localStore.getItem(this.reduceNavKey)
  }
}
